import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View, StyleSheet, TouchableWithoutFeedback } from 'react-native';
import {
    JDViewPager,
    JDImage
} from '@jdreact/jdreact-core-lib';
import { pt, formatJumpUrl, jumpByUrl, sendClickDataWithJsonParam} from '../../../../components/utiles';
import Indicator from './indicator';

const dataSource = new JDViewPager.DataSource({
    pageHasChanged: (p1, p2) => p1 !== p2
});

const DEFAULT_SIZES = {
    horizontal: {
        width: pt(702),
        height: pt(264)
    },
    vertical: {
        width: pt(348),
        height: pt(520)
    }
};

export default class BannerAds extends PureComponent {
    static defaultProps = {
        cityId: 1,
        bannerList: [],
        width: pt(702),
        height: pt(264),
        initPage: 0,
        style: {},
        direction: 'horizontal',
        autoPlay: true,
        indicatorContainerStyle: {},
        indicatorStyle: {},
        indicatorActiveStyle: {},
        needSendMta: false, // 是否需要发送埋点（如果父组件有自己的发送埋点的方法，需设置该值为false）
        pageId: '',
        eventId: '',
        isLoop: true,
        jsonParams: {},
        ext: {},
        mtaIndexName: 'index',
        onBeforeJump: () => {},
        onChangePage: () => {}
    }

    constructor(props) {
        super(props);
        this.state = {
            bannerList: [],
            activeIndex: 0,
            width: pt(702),
            height: pt(264),
        };
        this.viewPager = React.createRef();
    }

    componentDidMount() {
        const {
            width,
            height,
            direction,
            initPage
        } = this.props;
        if (width && height) {
            this.setState({
                width: width,
                height: height,
                activeIndex: initPage || 0
            });
        } else {
            const size = direction === 'vertical' ? DEFAULT_SIZES.vertical : DEFAULT_SIZES.horizontal;
            this.setState({
                width: size.width,
                height: size.height,
                activeIndex: initPage || 0
            });
        }
    }

    // 渲染轮播图
    _renderPage = (bannerList) => {
        const ds = dataSource.cloneWithPages(bannerList);
        const isSingle = !(bannerList && bannerList.length > 1);
        const {
            width,
            height
        } = this.state;
        const {
            autoPlay,
            isLoop,
            initPage
        } = this.props;
        return (
            <View>
                {
                    !!(width && height) && (
                        <JDViewPager
                            ref={this.viewPager}
                            style={[bannerAdStyle.bannerPage, { width, height }]}
                            initPage={initPage || 0}
                            isLoop={isLoop && !isSingle}
                            interval={3000}
                            nobounce={false}
                            locked={false}
                            renderPageIndicator={false}
                            width={width}
                            itemWidth={width}
                            dataSource={ds}
                            renderPage={this._renderPageContent}
                            autoPlay={autoPlay && !isSingle}
                            onChangePage={this._onChangePage}
                        />
                    )
                }
            </View>
        );
    }

    // 渲染轮播图内容
    _renderPageContent = (item, index) => {
        const {
            width,
            height
        } = this.state;
        const { cityId } = this.props
        const {
            imgUrl,
            jumpUrl
        } = item;
        return (
            <TouchableWithoutFeedback onPress={() => this._onAdClick(jumpUrl, index)}>
                <View key={cityId + '_' +index+'_'+jumpUrl} style={[bannerAdStyle.item, { width, height }]}>
                    <JDImage containerStyle={[bannerAdStyle.itemImgWrap, { width, height }]} style={bannerAdStyle.itemImg} source={{ uri: formatJumpUrl(imgUrl) }} resizeMode='contain' />
                </View>
            </TouchableWithoutFeedback>
        );
    }

    // 切换轮播图
    _onChangePage = (pageNumber) => {
        const {
            onChangePage,
        } = this.props;
        let bannerIndex = typeof pageNumber === 'number' ? pageNumber : pageNumber.nativeEvent.position;
        this.setState({
            activeIndex: bannerIndex
        });
        if (onChangePage && typeof onChangePage === 'function') {
            onChangePage(bannerIndex);
        }
    }

    _onAdClick = (url, index) => {
        const {
            onAdClick,
            eventId,
            jsonParams,
            onBeforeJump,
            needSendMta,
            ext,
            mtaIndexName
        } = this.props;
        const {
            activeIndex
        } = this.state;

        sendClickDataWithJsonParam({
            event_id: 'OfficeBuilding_Banner',
            page_id: this.props.pageId,
            json_param: {
                banner_sort: index + '',
                linkUrl: url
            },
        })

        if (onBeforeJump && typeof onBeforeJump === 'function') {
            onBeforeJump(url, index);
        }
        if (needSendMta) {
            if (mtaIndexName) {
                jsonParams[mtaIndexName] = activeIndex;
            }
        }
        if (onAdClick && typeof onAdClick === 'function') {
            onAdClick(url, index);
        } else {
            // res配置链接可能不规范，必须使用统一的jump方法进行跳转
            jumpByUrl(url);
        }
    }

    _renderIndicator() {
        const {
            activeIndex
        } = this.state;
        const {
            direction,
            indicatorContainerStyle,
            indicatorStyle,
            indicatorActiveStyle,
            bannerList
        } = this.props;
        if (direction === 'vertical') {
            return (
                <Indicator
                    itemStyle={[bannerAdStyle.indicatorVertical, indicatorStyle]}
                    itemActiveStyle={[bannerAdStyle.indicatorActiveVertical, indicatorActiveStyle]}
                    totalCount={bannerList.length}
                    activeIndex={activeIndex}
                    containerStyle={[bannerAdStyle.indicatorsVertical, indicatorContainerStyle]}
                />
            );
        }
        return (
            <Indicator
                itemStyle={[bannerAdStyle.indicator, indicatorStyle]}
                itemActiveStyle={[bannerAdStyle.indicatorActive, indicatorActiveStyle]}
                totalCount={bannerList.length}
                activeIndex={activeIndex}
                containerStyle={[bannerAdStyle.indicators, indicatorContainerStyle]}
            />
        );
    }

    // 跳转到指定页面
    goToPage(pageNumber) {
        if (this.viewPager && this.viewPager.current) {
            this.viewPager.current.goToPage(pageNumber);
        }
    }

    render() {
        const {
            bannerList,
            onLayout,
            style
        } = this.props;
        return (
            <View onLayout={onLayout}>
                {
                    bannerList && bannerList.length ? (
                        <View style={[bannerAdStyle.banner, style]}>
                            {this._renderPage(bannerList)}
                            {
                                bannerList.length > 1 && this._renderIndicator()
                            }
                        </View>
                    ) : null
                }
            </View>
        );
    }
}

BannerAds.propTypes = {
    isVisible: PropTypes.bool,
    bannerList: PropTypes.array.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    initPage: PropTypes.number,
    direction: PropTypes.oneOf(['horizontal', 'vertical']),
    autoPlay: PropTypes.bool,
    style: PropTypes.object,
    indicatorContainerStyle: PropTypes.object,
    indicatorStyle: PropTypes.object,
    indicatorActiveStyle: PropTypes.object,
    onBeforeJump: PropTypes.func,
    onChangePage: PropTypes.func,
    pageId: PropTypes.string,
    eventId: PropTypes.string,
    jsonParams: PropTypes.object,
    mtaIndexName: PropTypes.string,
    ext: PropTypes.object
};

const bannerAdStyle = StyleSheet.create({
    banner: {
        position: 'relative',
        backgroundColor: '#fff',
        borderRadius: pt(16),
        overflow: 'hidden'
    },
    bannerPage: {
        width: '100%'
    },
    item: {
        position: 'relative'
    },
    itemImg: {
        width: '100%',
        height: '100%'
    },
    itemActivity: {
        position: 'absolute',
        top: 0,
        right: 0,
        zIndex: 2
    },
    itemActivityImg: {
        width: pt(54),
        height: pt(30)
    },
    indicators: {
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: pt(12)
    },
    indicator: {
        width: pt(6),
        height: pt(6),
        backgroundColor: '#F2F2F2',
        marginHorizontal: pt(3)
    },
    indicatorActive: {
        width: pt(12),
        height: pt(6),
        backgroundColor: '#FA2C19',
        borderRadius: pt(9),
        marginHorizontal: pt(3)
    },
    indicatorsVertical: {
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: pt(16)
    },
    indicatorVertical: {
        width: pt(10),
        height: pt(10),
        backgroundColor: '#F2F2F2',
        marginHorizontal: pt(4)
    },
    indicatorActiveVertical: {
        width: pt(18),
        height: pt(10),
        backgroundColor: '#FA2C19',
        borderRadius: pt(10),
        marginHorizontal: pt(4)
    }
});
